import React from "react";

type MobileAgendaHeaderProps = {
  userFirstName: string;
  onBlockSlots?: () => void;
  canManageSchedules?: boolean;
  title?: string;
};

const MobileAgendaHeader: React.FC<MobileAgendaHeaderProps> = ({
  userFirstName,
  title = "Minha agenda",
}) => (
  <header className="mb-3 flex items-center justify-between gap-3">
    <div className="min-w-0">
      <p className="text-[15px] font-medium leading-tight text-[#718096]">
        Olá, {userFirstName}
      </p>
      <h1 className="mt-0.5 text-[28px] font-semibold leading-tight text-[#2D3748]">
        {title}
      </h1>
    </div>
  </header>
);

export default MobileAgendaHeader;
